import {NgModule} from '@angular/core';
import {AvatarComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {RoundProgressModule} from 'angular-svg-round-progressbar';

@NgModule({
    imports: [
        IonicModule,
        NgStyle,
        NgClass,
        NgIf,
        RoundProgressModule
    ],
  exports: [
    AvatarComponent
  ],
  declarations: [AvatarComponent],
  providers: [],
})
export class AvatarComponentModule {
}
